import Collapse from '@hellodarwin/core/lib/components/common/Collapse';
import { CollapsePanelHeader } from '@hellodarwin/core/lib/components/common/Collapse/styles';
import { Project } from '@hellodarwin/core/lib/features/entities/projects-entities';
import { createFontSizeCSS } from '@hellodarwin/core/lib/theme/global-style';
import Table from 'antd/es/table';
import styled from 'styled-components';

export const ProjectsTableStyled = styled(Table<Project>)`
  .ant-table {
    border-radius: 0;
  }
  table {
    border-spacing: 0 16px;
  }
  .ant-table-thead {
    & > tr {
      & > th {
        &:before {
          display: none;
        }
        padding-block: 10px;
        ${createFontSizeCSS('overline')}
        font-weight:500;
        text-transform: uppercase;
        background: ${({ theme }) => theme.colors.transparent};
        border-bottom: 1px solid ${({ theme }) => theme.colors.grey_4};
        &:first-child {
          padding-inline-start: 24px;
        }
        &:last-child {
          padding-inline-end: 24px;
        }
      }
    }
  }
  .ant-table-tbody {
    ${createFontSizeCSS('body3')}
    .ant-table-measure-row {
      display: none;
    }
    & > .ant-table-row {
      height: 85px;
      cursor: pointer;
      & > .ant-table-cell-row-hover {
        background: ${({ theme }) => theme.colors.purple_5};
        transform: translateY(-2px);
      }
      & > td {
        background: ${({ theme }) => theme.colors.white_1};
        &.actions-column {
          padding: 0;
          & > * {
            margin: auto;
          }
        }
        &:first-child {
          border-left: 1px solid ${({ theme }) => theme.colors.grey_1};
          padding-inline-start: 24px;
        }
        &:last-child {
          border-right: 1px solid ${({ theme }) => theme.colors.grey_1};
          padding-inline-end: 24px;
        }
        border-top: 1px solid ${({ theme }) => theme.colors.grey_1};
        border-bottom: 1px solid ${({ theme }) => theme.colors.grey_1};
      }
    }
  }
`;

export const ProjectsTableContent = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.md}px;
`;

export const SubsidiaryCollapse = styled(Collapse)`
  .ReactCollapse--content {
    border-top: none;
    padding: 0 16px 16px 16px;
  }

  ${CollapsePanelHeader} {
    justify-content: flex-end;
  }
`;

export const EmptyProjectsContainer = styled.div`
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm}px;
  align-items: center;
  padding-block: 54px;
`;
